import { request } from "/src/utils/index.js";

export function Search(params) {
  // console.log(parmas);
  return request.get("sys/group/list", { params });
}

export function Detail(params) {
  // console.log(parmas);
  return request.get("sys/group" + params);
}

export function Add(params) {
  return request.post("sys/group", params);
}

export function Update(params) {
  return request.put("sys/group", params);
}

export function Delete(data) {
  return request.delete("sys/group", { data });
}

